const BASE_URL = process.env.REACT_APP_API_URL || "";
const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN || ""; 

/**
 * Global Fetcher for Worker API
 * Handles Header Injection and Error Logging
 */
async function fetcher(endpoint) {
  if (!BASE_URL) {
    throw new Error("REACT_APP_API_URL is missing in .env");
  }

  const cleanBase = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL;
  const url = `${cleanBase}${endpoint}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${AUTH_TOKEN.trim()}`,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    if (response.status === 401) {
      console.error("Auth Error: Cloudflare Worker rejected the token.");
    }
    if (response.status === 404) {
      console.warn("Resource not found:", endpoint);
    }
    throw new Error(`API Error: ${response.status}`);
  }

  return await response.json();
}

/**
 * Job API Service Object
 */
export const jobApi = {
  getJobsByState: async (stateSlug = "") => {
    return await fetcher('/jobs');
  },

  getJobById: async (id) => {
    if (!id) throw new Error("Job ID is required");
    return await fetcher(`/jobs/${id}`);
  },

  getAllJobsByCity: async () => {
    return await fetcher('/jobs');
  }
};

/**
 * NEW: News API Service Object
 * Fetches the daily AI news JSON from R2 via the Worker
 */
export const newsApi = {
  /**
   * Used by Insights.jsx
   * Fetches the daily news sync: { metadata: {...}, news: [...] }
   */
  getLatestAINews: async () => {
    try {
      // Calls the /news endpoint on your Cloudflare Worker
      return await fetcher('/news');
    } catch (error) {
      console.error("Failed to fetch AI news via Worker:", error);
      // Return a structured empty object so the UI doesn't crash
      return { metadata: { status: "Offline" }, news: [] };
    }
  }
};